export default __webpack_public_path__ + "media/Objective/Objective-Thin-c67a1924ba0d0f1dd6539a1f4965ad7f.woff2";